import { Typography } from '@mui/material';
import StyledBox from './styled/PendingRequest/StyledBox';
import LogoComponent from '../logo/LogoComponent';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PendingRequest = () => {
  const location = useLocation();

  const navigate = useNavigate();

  const isProgrammatic = location.state?.isProgrammatic || false;

  useEffect(() => {
    if (!isProgrammatic) {
      navigate('/auth/sign-in');
    } else {
      window.history.replaceState({}, '');
    }
  }, [isProgrammatic]);

  return (
    <StyledBox sx={{ width: '100%' }}>
      <Typography
        component='h1'
        variant='h5'
        sx={{ fontSize: '1.875rem', marginTop: '1.25rem' }}
      >
        Request is Pending
      </Typography>
      <Typography sx={{ width: '55%', textAlign: 'center' }}>
        You will gain full access to the service once your account has been
        approved by the Admin.
      </Typography>
    </StyledBox>
  );
};

export default PendingRequest;
